<div class="login">
  <div id="login-container">
    <!--
  Auth-lock is looking for a container to be placed in. In case there is no container in auth options,
  auth adds automatically 'auth0-lock-container' container to the DOM. I used a new id to have at least control
  where the container physically is to place expire message above it.
  -->
    <div id="login-auth-container"></div>
  </div>
</div>
